<template>
    <el-tooltip

        class="service"
        popper-class="tooltip-text"
        placement="top"
        :disabled="!(service.description != '' && service.description != 'N/A' && service.description != null)">

        <!-- Extra description tooltip -->
        <template slot="content">{{ service.description }}</template>

        <div @click="$emit('click')"  :class="{ active: (isActive) }" style="cursor: pointer;">

            <!-- Extra Icon -->
            <div class="service-icon">
                <img v-if="service.icon_url" :src="service.icon_url" height="36"/>
                <img v-else src="/images/cleaning.png" />
            </div>

            <!-- Name & Price -->
            <div class="service-name">{{ service.name }}</div>
            <div class="service-price">{{ currency }}{{ service.price }}</div>


        </div>

    </el-tooltip>
</template>

<script>
    export default {
        data(){
            return {
                counter: 0,
            }
        },
        props: {
            service: {
                type: Object,
                required: true,
            },
            isActive: {
                type: Boolean,
            },
            currency: {
                type: String,
            }
        },
        methods: {

        },
    }
</script>

<style>
    .tooltip-text {
        font-family: 'Inter', sans-serif;
        max-width: 300px;
        border-radius: 6px;
    }

    .tooltip-text::first-letter {
        text-transform: uppercase;
    }
</style>

<style lang="scss" scoped>

    .service {
        border: 1.5px solid #E5E9EF;
        border-radius: 16px;
        padding: 16px;
        padding-top: 0;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        &:hover {
            .el-input-number__decrease, .el-input-number__increase {
                display: flex;
            }
        }
    }

    .active {
        border: 1.5px solid var(--color-primary);
    }

    .service-icon {
        width: 72px;
        height: 72px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 auto;
    }

    .service-name {
        font-size: 12px;
        text-align: center;
        color: #8492A6;
        margin-bottom: 3px;
    }

    .service-price {
        font-size: 13px;
        text-align: center;
        font-weight: 600;
        color: var(--color-primary);
    }

    .service-input-number {
        position: absolute;
        display: flex;
        justify-content: space-between;
        background: transparent;
        min-width: calc(100% + 22px);
        top: 50%;
        transform: translateY(-50%);
        padding: 0 4px;

        .el-input-number__container {
            background-color: white;
        }
    }

    .service-quantity-number::v-deep {
        position: absolute;
        bottom: -9px;
        background: white;
        padding: 0 4px;

        .el-input-number--mini {
            width: unset;
            min-width: 80px;
        }

        .el-input--mini {
            .el-input__inner {
                height: 22px;
            }
        }
    }


    .disabled {
        opacity: 0.3;
        cursor: default;
    }

</style>
